var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyInit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.75C20.7648 1.75 26.25 7.23516 26.25 14C26.25 20.7648 20.7648 26.25 14 26.25C7.23516 26.25 1.75 20.7648 1.75 14C1.75 7.23516 7.23516 1.75 14 1.75ZM8.75 14.6562C8.75 14.7766 8.84844 14.875 8.96875 14.875H13.125V19.0312C13.125 19.1516 13.2234 19.25 13.3438 19.25H14.6562C14.7766 19.25 14.875 19.1516 14.875 19.0312V14.875H19.0312C19.1516 14.875 19.25 14.7766 19.25 14.6562V13.3438C19.25 13.2234 19.1516 13.125 19.0312 13.125H14.875V8.96875C14.875 8.84844 14.7766 8.75 14.6562 8.75H13.3438C13.2234 8.75 13.125 8.84844 13.125 8.96875V13.125H8.96875C8.84844 13.125 8.75 13.2234 8.75 13.3438V14.6562Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyInit);
export default __webpack_public_path__ + "static/media/grey-init.44da2ee1aae642372df325f30612c7b6.svg";
export { ForwardRef as ReactComponent };